import { Area } from "./area";
import { Division } from "./division";
import { EmployeePositionHistory } from "./employee-position-history";
import { EmployeeSalaryHistory } from "./employee-salary-history";
import { Person } from "./person";
import { Position } from "./position";

export class Employee {
    id: number = 0;
    employeeNumber!: string;
    person: Person = new Person();
    baseSalary!: string;
    division: Division = new Division();
    area: Area = new Area();
    position: Position = new Position();
    workLocation!: string;
    positionText!: string;
    
    employeePositionHistories: EmployeePositionHistory[] = [];
    employeeSalaryHistories: EmployeeSalaryHistory[] = [];
}